module.exports = __webpack_public_path__ + "img/france-blood-diseases-female.ec1f43e2.png";